"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TagPickerOption", {
    enumerable: true,
    get: function() {
        return TagPickerOption;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTagPickerOption = require("./useTagPickerOption");
const _renderTagPickerOption = require("./renderTagPickerOption");
const _useTagPickerOptionStylesstyles = require("./useTagPickerOptionStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TagPickerOption = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTagPickerOption.useTagPickerOption_unstable)(props, ref);
    (0, _useTagPickerOptionStylesstyles.useTagPickerOptionStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTagPickerOptionStyles_unstable')(state);
    return (0, _renderTagPickerOption.renderTagPickerOption_unstable)(state);
});
TagPickerOption.displayName = 'TagPickerOption';
